import {createUseStyles} from "react-jss";

export const useStyles = createUseStyles({
    root:{
        display:"flex",
        flexWrap: "wrap",
    },
    events:{
        minWidth: 200,
        maxWidth: "100%",
        margin: 4,
        flexGrow: 1,
    },
    referer:{
        minWidth: 200,
        maxWidth: "100%",
        flexGrow: 1,
        margin: 4,
    }
});